<template>
    <div class="title-template-table  table-responsive">
        <table class="table table-hover table-head-fixed table-hover mb-3">
            <thead>
                <tr>
                    <th>Icon</th>
                    <th>Tiêu đề</th>
                    <th>Kiểu</th>
                    <th class="text-right">
                        <span class="btn-add float-right pr-2" @click="create">
                            <i class="icon16-plus-circle-gadient"></i> Thêm mới
                        </span>
                    </th>
                </tr>
            </thead>
            <tbody v-if="!items || !items.length" >
                <tr>
                    <td colspan="4" class="text-center text-danger"> {{label}} trống</td>
                </tr>
            </tbody>
            <draggable v-model="items" @change="move" tag="tbody">
                <tr v-for="(item, index) in items" :key="index" class="tr-draggable">
                    <td>
                        <img v-if="item.anh && files[item.anh]" :src="files[item.anh]" class="rounded-circle img-thumbnail" style="width:50px; height: 50px" />
                    </td>
                    <td><a :href="item.link" target="_blank">{{ item.title }}</a></td>
                    <td>{{ this.typeOptions.find(e => e.value == item.type).text }}</td>
                    <td class="text-right">
                        <button type="button" class="btn-sm btn btn-sm btn-outline-gray mb-1">
                            <i class="fa fa-arrows-alt mr-0"></i>
                        </button>
                <g-button :loading="updateLoading" size="sm" variant="outline-info" class="ml-1 mb-1" icon="pencil" @click='update(index)'/>
                <g-button :loading="delLoading" size="sm" variant="outline-danger" class="ml-1 mb-1" icon="trash-fill" @click='del(index)' />
                </td>
                </tr>
            </draggable>
        </table>
        <b-modal v-model="showForm" :title="`${formTitle} ${label}`" no-close-on-backdrop no-enforce-focus>
            <form-input  :required='true' label="Tiêu đề" :model="formModel" attribute="title" :errors="formErrors" />
            <form-select  :required='true' label="Kiểu tỉ lệ" :model="formModel" attribute="type" :errors="formErrors" :options="typeOptions"/>
            <form-input  :required='true' label="Hiện trạng" :model="formModel" attribute="current" :errors="formErrors" />
            <form-input  :required='true' label="Mục tiêu" :model="formModel" attribute="target" :errors="formErrors" />
            <form-media :required='true'  :model="formModel" label="Icon" attribute="anh"  :placeholder="imageSize ? `Chọn Hình ảnh (Kích thước tiêu chuẩn: ${imageSize}px)` : `Chọn Hình ảnh`" :errors="formErrors" accept="image/jpeg,image/png,image/jpg,image/svg+xml"  />
            <template v-slot:modal-footer>
                <b-button variant="secondary" class="float-right" @click="showForm = false">Huỷ</b-button>
                <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="save">
                    <b-spinner v-if="saveLoading" small></b-spinner>
                    Lưu lại
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import draggable from 'vuedraggable'
    import crud from '@/mixins/CRUD';
    import FormMedia from '@/components/media/FormMedia';

    export default {
        mixins: [crud],
        components: {draggable, FormMedia},
        props: ['model', 'attribute', 'label', 'imageSize'],
        data() {
            return {
                defaultFormModel: {
                    anh: null,
                    title: null,
                    current: null,
                    target: null,
                    type: null
                },
                items: this.model[this.attribute] ? this.model[this.attribute] : [],
                state: null,
                errorTxt: '',
                formErrors: {},
                files: {},
                typeOptions: [
                    {value: null, text: "Chọn kiểu"},
                    {value: 1, text: "Tỉ lệ"},
                    {value: 2, text: "Diện tích"},
                ],
            }
        },
        watch: {
            model: {
                handler(val) {
                    this.state = null;
                    this.errorTxt = '';
                    if (val[this.attribute] && val[this.attribute] !== null) {
                        this.items = val[this.attribute];
                    } else {
                        this.items = null;
                    }
                }, deep: true
            },
            items(val) {
                this.state = null;
                this.errorTxt = '';
                this.model[this.attribute] = val;
            },
            errors(val) {
                let hasErr = false;
                if (val.length) {
                    val.forEach(v => {
                        if (v.param === this.attribute) {
                            this.state = false;
                            this.errorTxt = v.msg;
                            hasErr = true;
                            return;
                        }
                    });
                }
                if (!this.errorOnly) {
                    this.state = !hasErr;
                }
            }
        },
        methods: {
            load() {
                if (this.items) {
                    let ids = this.items.map(i => i.anh).join(',');
                    if (ids) {
                        this.loading = true;
                        this.$service.get(`media/gets`, {
                            params: {ids: ids}
                        }).then(response => {
                            this.files = [];
                            for (let item of response.data) {
                                this.files[item.id] = item.url;
                            }
                        }).finally(() => {
                            this.loading = false;
                        });
                    } else {
                        this.files = [];
                    }
                }
            },
            validators: function () {
                this.formErrors = {};
                if (this.formModel.desc === null || this.formModel.desc === '') {
                    this.formErrors.desc = ["Mô tả không được để trống"];
                } else if (this.formModel.desc.length > 500) {
                    this.formErrors.desc = ["Mô tả không được quá 500 ký tự"];
                }

                if (this.formModel.title === null || this.formModel.title === '') {
                    this.formErrors.title = ["Tiêu đề không được để trống"];
                } else if (this.formModel.title.length > 220) {
                    this.formErrors.title = ["Tiêu đề không được quá 220 ký tự"];
                }

                /* eslint-disable no-useless-escape */
                let pattern = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
                if (this.formModel.link === null || this.formModel.link === '') {
                    this.formErrors.link = ["Đường dẫn không được để trống"];
                } else if (!pattern.test(this.formModel.link)) {
                    this.formErrors.link = ["Đường dẫn không đúng định dạng (http://*, https://*)"];
                }

                if (!this.formModel.anh) {
                    this.formErrors.anh = ["Ảnh không được để trống"];
                }
            },
            save: function (evt) {
                this.items = !this.items || !this.items.length ? [] : this.items;
                evt.preventDefault();
                this.validators();
                if (Object.keys(this.formErrors).length > 0) {
                    return false;
                }
                if (!this.formModel.id) {
                    this.items.push(this.formModel);
                } else {
                    this.items[this.formModel.id] = this.formModel;
                }
                this.showForm = false;
                this.load();

            },
            move: function () {

            },
            update: function (index) {
                this.formModel = {};
                this.formTitle = "Cập nhật";
                this.formErrors = [];
                this.showForm = true;
                this.formModel = {...this.items[index]};
                this.formModel.id = `${index}`;
            },
            del: function (index) {
                this.$swal({
                    title: "Bạn chắc chắn muốn xóa chứ?",
                    text: "Sẽ không thể khôi phục lại dữ liệu đã xóa!",
                    icon: "warning",
                    showCancelButton: true
                }).then((result) => {
                    if (result.value) {
                        if (result.value) {
                            this.items.splice(index, 1);
                        }
                    }
                });
            },
        },
        mounted() {
            this.items = this.model[this.attribute] ? this.model[this.attribute] : [];
            this.load();
        }
    }
</script>
